export default __webpack_public_path__ + "static/media/Hristo Boyadzhiev.82fe8208.png";